import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useManagePortfoliosPracticesStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "auto",
    paddingLeft: designTokens.spacing[8],
    paddingRight: designTokens.spacing[8],
  },

  tabBar: {
    marginBottom: designTokens.spacing[1],
  },

  tabContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    paddingLeft: designTokens.spacing[4],
    paddingRight: designTokens.spacing[8],
  },

  fieldError: {
    marginTop: designTokens.spacing[1],
    fontSize: designTokens.fontSize.xs,
    color: designTokens.semantic.error,
  },

  dialogField: {
    marginBottom: designTokens.spacing[4],
  },
});
